export const DEFAULT_CHAT_LANGUAGE = 'en';

export const CHAT_LANGUAGES = [
  { code: 'en', label: 'English', symbol: 'ENG' },
  { code: 'hi', label: 'Hindi', symbol: 'HIN' },
  { code: 'es', label: 'Spanish', symbol: 'SPA' },
  { code: 'fr', label: 'French', symbol: 'FRA' },
  { code: 'de', label: 'German', symbol: 'GER' },
  { code: 'pt', label: 'Portuguese', symbol: 'POR' },
  { code: 'ar', label: 'Arabic', symbol: 'ARA' },
  { code: 'zh', label: 'Chinese', symbol: 'CHI' },
  { code: 'ja', label: 'Japanese', symbol: 'JPN' },
  { code: 'ko', label: 'Korean', symbol: 'KOR' },
  { code: 'bn', label: 'Bengali', symbol: 'BEN' },
  { code: 'ta', label: 'Tamil', symbol: 'TAM' },
  { code: 'te', label: 'Telugu', symbol: 'TEL' },
  { code: 'mr', label: 'Marathi', symbol: 'MAR' },
  { code: 'gu', label: 'Gujarati', symbol: 'GUJ' },
  { code: 'pa', label: 'Punjabi', symbol: 'PAN' },
  { code: 'ur', label: 'Urdu', symbol: 'URD' },
  { code: 'ru', label: 'Russian', symbol: 'RUS' },
  { code: 'it', label: 'Italian', symbol: 'ITA' },
  { code: 'nl', label: 'Dutch', symbol: 'DUT' },
  { code: 'tr', label: 'Turkish', symbol: 'TUR' },
  { code: 'vi', label: 'Vietnamese', symbol: 'VIE' },
  { code: 'th', label: 'Thai', symbol: 'THA' },
  { code: 'id', label: 'Indonesian', symbol: 'IND' },
];

export const normalizeChatLanguage = (value) => {
  const code = String(value || '').trim().toLowerCase().split(/[-_]/)[0].slice(0, 2);
  return CHAT_LANGUAGES.some((item) => item.code === code) ? code : DEFAULT_CHAT_LANGUAGE;
};

export const chatLanguageSymbol = (value) => {
  const code = normalizeChatLanguage(value);
  return CHAT_LANGUAGES.find((item) => item.code === code)?.symbol || 'ENG';
};

export const chatLanguageLabel = (value) => {
  const code = normalizeChatLanguage(value);
  return CHAT_LANGUAGES.find((item) => item.code === code)?.label || 'English';
};

const SPEECH_LOCALES = {
  en: 'en-IN',
  hi: 'hi-IN',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  pt: 'pt-BR',
  ar: 'ar-SA',
  zh: 'zh-CN',
  ja: 'ja-JP',
  ko: 'ko-KR',
  bn: 'bn-IN',
  ta: 'ta-IN',
  te: 'te-IN',
  mr: 'mr-IN',
  gu: 'gu-IN',
  pa: 'pa-IN',
  ur: 'ur-IN',
  ru: 'ru-RU',
  it: 'it-IT',
  nl: 'nl-NL',
  tr: 'tr-TR',
  vi: 'vi-VN',
  th: 'th-TH',
  id: 'id-ID',
};

export const speechRecognitionLang = (preferredLanguage) => {
  const code = normalizeChatLanguage(preferredLanguage);
  const nav = typeof navigator !== 'undefined' ? String(navigator.language || '') : '';
  if (nav && nav.toLowerCase().startsWith(code)) return nav;
  return SPEECH_LOCALES[code] || `${code}-${code.toUpperCase()}`;
};

/** Incoming chat body for this viewer. Own messages stay original.
 *  Only use a translation already stored for this language (from send time).
 *  Do not invent a new translation when the viewer later changes language. */
export const messageBodyForViewer = (msg, preferredLanguage, isOwn = false) => {
  const original = msg?.content || '';
  if (isOwn) return original;
  const lang = normalizeChatLanguage(preferredLanguage);
  const source = normalizeChatLanguage(msg?.sourceLanguage || DEFAULT_CHAT_LANGUAGE);
  if (lang === source) return original;
  return msg?.translations?.[lang] || original;
};

export const isChatTranslationPending = (msg, preferredLanguage, isOwn = false) => {
  if (!msg || isOwn || msg.translationPending !== true) return false;
  const lang = normalizeChatLanguage(preferredLanguage);
  const source = normalizeChatLanguage(msg.sourceLanguage || DEFAULT_CHAT_LANGUAGE);
  if (lang === source) return false;
  return !msg.translations?.[lang];
};
